import {
    ADD_PRODUCTO_CAJA_DE_ZONA, MODIFY_PRODUCTO_CAJA_DE_ZONA, DELETE_PRODUCTO_CAJA_DE_ZONA
} from '../constants/action_types';


export function modifyProductoCajaDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_PRODUCTO_CAJA_DE_ZONA, payload: producto });
    }
}

export function addProductoCajaDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_PRODUCTO_CAJA_DE_ZONA, payload: producto });
    }
}

export function removeProductoCajaDeZona(producto) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_PRODUCTO_CAJA_DE_ZONA, payload: producto });
    }
}
